import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions } from '../../reducers/actions';
import { CategoryService } from '../../services';
import { editedCategoryAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_CATEGORY),
    switchMap(action =>
      CategoryService.edit(action.category, store).pipe(
        map(data => editedCategoryAction(data)),
        catchError(retryAuthentication(action$, 'epics/categories/editCategory'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/categories/editCategory.js